export const hostNameMatterPort = 'my.matterport.com'
export const modelIdParamName = 'm'
